module.exports = __webpack_public_path__ + "img/fr_Beta Digitis - Gif.2f09e339.gif";